enum TableWidth {
    Full = "full",
    Half = "half",
    ThreeQuarters = "three-quarters",
}
export default TableWidth;
